import { PROMOTION_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

export {
  DEFAULT_BG_COLOR_FIELDS as BG_COLOR_FIELDS,
  BUTTON_SUFFIX_UPLOAD_FIELDS as UPLOAD_FIELDS
} from '../FormFields.consts';

export const FONT_WEIGHT_OPTIONS = [
  { value: 'normal', label: 'Regular' },
  { value: 'bold', label: 'Bold' },
  { value: 'bolder', label: 'Bolder' }
];

export const TITLE_DEFAULTS = {
  fontColor: PROMOTION_DEFAULTS.fontColor,
  fontSize: PROMOTION_DEFAULTS.fontSize
};
